module.exports = __webpack_public_path__ + "static/media/ic-account.5c2fc388.svg";